import { Routes } from "@angular/router";

import { AdminLayoutComponent } from "./layouts/admin/admin-layout.component";
import { AuthLayoutComponent } from "./layouts/auth/auth-layout.component";

import { GraphComponent } from "./analytics/graph/graph.component";
import { HistogramComponent } from "./analytics/histogram/histogram.component";
import { EpackLifecycleTrackingComponent } from "./epack-lifecycle-tracking/epack-lifecycle-tracking.component";
import { BmsipqcComponent } from "./exponent/bmsipqc/bmsipqc.component";
import { ExponentEpackComponent } from "./exponent/epack/epack.component";
import { ExponentEvaComponent } from "./exponent/eva/exponent-eva.component";
import { PdiLiteComponent } from "./exponent/pdi/pdi-lite/pdi-lite.component";
import { ExponentPdiComponent } from "./exponent/pdi/pdi.component";
import { DashboardComponent } from "./oto/retrofit/dashboard/dashboard.component";
import { VahanPortalComponent } from "./oto/vahan-portal/vahan-portal.component";
import { AuthGuardService as AuthGuard } from "./services/auth-guard.service";
import { RetrofitRawDataComponent } from "./oto/retrofit/retrofit-raw-data/retrofit-raw-data.component";

const defaultRoute = localStorage.getItem("default_url") ?? "/";

export const AppRoutes: Routes = [
  {
    path: "",
    redirectTo: defaultRoute,
    pathMatch: "full",
  },
  {
    path: "",
    component: AdminLayoutComponent,
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    children: [
      // sidebar based routings: redirects to module based routings
      {
        path: "pack-lifecycle",
        component: EpackLifecycleTrackingComponent,
      },
      {
        path: "bms-ipqc",
        component: BmsipqcComponent,
      },
      {
        path: "pdi",
        component: ExponentPdiComponent,
      },
      {
        path: "pdi-lite",
        component: PdiLiteComponent,
      },
      {
        path: "eol",
        children: [
          {
            path: "epack",
            component: ExponentEpackComponent,
          },
          {
            path: "raw-data",
            component: ExponentEvaComponent,
          },
          {
            path: "graph",
            component: GraphComponent,
          },
          {
            path: "histogram",
            component: HistogramComponent,
          },
        ],
      },
      {
        path: "retrofit",
        children: [
          { path: "dashboard", component: DashboardComponent },
          { path: "vahan", component: VahanPortalComponent },
          { path: "raw-data", component: RetrofitRawDataComponent },
        ],
      },
      // lazy loading routes
      {
        path: "master",
        loadChildren: "./master/master.module#MasterModule",
      },
      {
        path: "",
        loadChildren: "./config/config.module#ConfigModule",
      },
    ],
  },
  {
    path: "",
    component: AuthLayoutComponent,
    children: [
      {
        path: "pages",
        loadChildren: "./pages/pages.module#PagesModule",
      },
    ],
  },
  {
    path: "**",
    redirectTo: defaultRoute,
    pathMatch: "full",
  },
];
